import { Link } from "react-router-dom";
import cn from 'classnames';
import { IMenu } from "../configs/header";

type IAccordion = {
  item: IMenu;
  index: number;
  selected: number | null;
  toggle: (i: number) => void;
  toggleSidebar: () => void;
}

function Accordion({item, index, selected, toggle, toggleSidebar}: IAccordion) {

  return (
    <>
      <button
        type="button"
        className="flex items-center justify-between w-full gap-x-3.5 py-4 px-4 bg-gray-100 text-lg text-black rounded-lg"
        onClick={() => toggle(index)}
        aria-expanded={selected === index}
      >
        <span className="flex items-center gap-x-3.5">
          {item.icon && <item.icon />}
          {item.text}
        </span>
        <div className={cn('transition-[transform]', {
          'rotate-180': selected === index
        })}>
          <svg data-accordion-icon className="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5"/>
          </svg>
        </div>
      </button>

      <div
        className={`overflow-hidden transition-all duration-200 !m-0 ${
          selected === index ? "max-h-screen" : "max-h-0"
        }`}
        style={{
          maxHeight: selected === index ? "1000px" : "0px",
        }}
      >
        <ul className="mx-3 mt-2 space-y-1">
          <li key={item.text.replace(' ', '')}>
            <Link
              className="flex items-center gap-x-3.5 py-3 px-2.5 text-lg bg-gray-50 text-black rounded-lg"
              to={item.link}
              onClick={toggleSidebar}
            >
              Vedi {item.text.toLowerCase()}
            </Link>
          </li>
          {item.items.map((subItem, index) => (
            <li key={`${subItem.text.replace(' ', '')}-${index}`}>
              <Link
                className="flex items-center gap-x-3.5 py-3 px-2.5 text-lg bg-gray-50 text-black rounded-lg"
                to={subItem.link}
                onClick={toggleSidebar}
              >
                {subItem.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Accordion;
